import { DepartmentState } from "./types";

const state: DepartmentState = {
  departments: [],
  createLoading: false,
};

export default state;
